module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "TutorHistory2"
  }, [_c('h1', {
    staticClass: "m-label",
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v("対応履歴")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "calc(100vh - 241px)"
    }
  }, [_c('transition', {
    attrs: {
      "name": "loading",
      "mode": "out-in"
    }
  }, [(_vm.tutor.tutorsupports) ? [_c('div', [_c('div', {
    staticClass: "is-print-overflow",
    class: _vm.condition.condition ? 'm-support__inner is-shrink' : 'm-support__inner is-normal'
  }, [_c('div', {
    class: {
      'small': _vm.type
    }
  }, [_c('p', [_c('span', {
    staticClass: "fa",
    on: {
      "click": function($event) {
        return _vm.sort("support_date")
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-alpha-desc"
  }), _vm._v("ソート"), _c('i', {
    staticClass: "fa fa-fw fa-angle-down"
  })]), _vm._v(" "), _c('span', [(this.sortColumn === 'support_date') ? [_vm._v("対応日")] : _vm._e(), _vm._v("\n                  : " + _vm._s(_vm.sortState) + "\n                ")], 2)]), _vm._v(" "), _c('ul', {
    staticClass: "m-supportList"
  }, _vm._l((_vm.mapTutorsupports), function(list) {
    return _c('li', {
      key: list.id,
      staticClass: "m-supportItem m-supportItem--happy",
      attrs: {
        "transition": "expand"
      }
    }, [(list.support_tags) ? [(list.support_tags.length > 0) ? [_c('div', {
      staticClass: "m-supportItem__border",
      style: ({
        'backgroundColor': list.support_tags[0].tag.color
      })
    })] : [_c('div', {
      staticClass: "m-supportItem__border",
      style: ({
        'backgroundColor': '#607D8B'
      })
    })]] : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "m-supportItem__header"
    }, [_c('div', {
      staticClass: "m-supportItem__avatar"
    }, [(list.user) ? [_c('div', {
      staticClass: "user-icon-history"
    }, [_vm._v(_vm._s((list.user.user).charAt(0)))])] : [_c('div', {
      staticClass: "user-icon-history"
    }, [_vm._v("未")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(list.user_id))])]], 2), _vm._v(" "), _c('time', [(list.user) ? [_c('p', [_vm._v(_vm._s(list.user.user))])] : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(list.mapSupport_date))]), _vm._v(" "), _c('ul', {
      staticClass: "m-link is-print-none"
    }, [_c('li', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.edit(list)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    }), _vm._v("編集")]), _vm._v(" "), _c('a', {
      on: {
        "click": function($event) {
          return _vm.deleteTutorsupport(list)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o"
    }), _vm._v("削除")])])])], 2), _vm._v(" "), _c('div', {
      staticClass: "tagInput is-print-none"
    }, [_c('i', {
      staticClass: "fa fa-tag"
    }), _vm._v(" "), _c('multiselect', {
      attrs: {
        "options": _vm.tags,
        "label": "name",
        "show-labels": false,
        "placeholder": "タグ追加"
      },
      on: {
        "select": _vm.select
      },
      model: {
        value: (_vm.tag),
        callback: function($$v) {
          _vm.tag = $$v
        },
        expression: "tag"
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-plus",
      on: {
        "click": function($event) {
          return _vm.postSupportTag(list)
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "m-tag"
    }, _vm._l((list.support_tags), function(list) {
      return _c('span', {
        key: list.id
      }, [_c('tag', {
        style: ({
          'backgroundColor': list.tag.color
        })
      }, [_c('i', {
        staticClass: "fa fa-fw fa-times",
        on: {
          "click": function($event) {
            return _vm.deleteSupportTag(list)
          }
        }
      }), _vm._v(_vm._s(list.tag.name))])], 1)
    }), 0)]), _vm._v(" "), (list.id == _vm.edit_id.list_id) ? [_c('div', {
      staticClass: "m-supportItem__main"
    }, [_c('vue-html5-editor', {
      attrs: {
        "content": list.note,
        "auto-height": false
      },
      on: {
        "change": function($event) {
          return _vm.patchNote(list, $event)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.patch.support_date),
        expression: "patch.support_date"
      }],
      key: "edit_id-input",
      staticClass: "support_date",
      attrs: {
        "type": "text",
        "placeholder": "対応日"
      },
      domProps: {
        "value": (_vm.patch.support_date)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.patch, "support_date", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "m-supportItem__edit-btn"
    }, [_c('button', {
      on: {
        "click": function($event) {
          return _vm.patchTutorsupport(list)
        }
      }
    }, [_vm._v("更新")]), _c('button', {
      on: {
        "click": _vm.cancelTutorsupport
      }
    }, [_vm._v("キャンセル")])])], 1)] : [_c('div', {
      staticClass: "m-supportItem__main"
    }, [_c('div', {
      staticClass: "vue-html",
      domProps: {
        "innerHTML": _vm._s(list.note)
      }
    })])]], 2)
  }), 0)])]), _vm._v(" "), _c('div', {
    class: _vm.condition.condition ? 'm-support__inner2 is-show' : 'm-support__inner2 is-hide'
  }, [_c('div', {
    class: {
      'small': _vm.type
    }
  }, [_c('div', {
    staticClass: "m-supportItem2"
  }, [_c('div', {
    staticClass: "m-supportItem2__border m-supportItem2__border--add"
  }), _vm._v(" "), _c('div', {
    staticClass: "m-supportItem2__header"
  }), _vm._v(" "), _c('div', {
    staticClass: "m-supportItem2__main"
  }, [_c('vue-html5-editor', {
    attrs: {
      "content": _vm.support.note,
      "auto-height": false
    },
    on: {
      "change": _vm.changeNote
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.support.support_date),
      expression: "support.support_date"
    }],
    staticClass: "support_date",
    attrs: {
      "type": "text",
      "placeholder": "対応日"
    },
    domProps: {
      "value": (_vm.support.support_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.support, "support_date", $event.target.value)
      }
    }
  })])], 1)])])])])] : [_c('loading')]], 2)], 1), _vm._v(" "), (_vm.condition.condition == false) ? [_c('btn', {
    staticClass: "is-print-none",
    nativeOn: {
      "click": function($event) {
        return _vm.slide($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-up"
  }), _vm._v("対応履歴入力")])] : [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.postSupport($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _vm._v("新規追加")]), _vm._v(" "), _c('btn', {
    staticClass: "support-cxl",
    nativeOn: {
      "click": function($event) {
        return _vm.slide($event)
      }
    }
  }, [_vm._v("キャンセル")])], 1)]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14caad87"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/Tutor/TutorHistory2.vue
// module id = 1295
// module chunks = 0